import React from 'react';
import { Menu, MenuButton, SubMenu, MenuItem } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';

import opsProm from '../locales/operations.promql.json';
import opsLoki from '../locales/operations.loki.json';

export default function OperationMenu({ mode = 'promql', onAdd, isDark = false }){
  const spec = mode === 'promql' ? opsProm : opsLoki;
  const buttonStyle = isDark ? { background: '#21262d', border: '1px solid #30363d', color: '#e6edf3' } : undefined;
  return (
    <Menu menuButton={<MenuButton className='gb-op-add' style={buttonStyle}>+ Operations ▾</MenuButton>} transition>
      {Object.entries(spec).map(([cat, items]) => (
        <SubMenu key={cat} label={cat}>
          {Array.isArray(items) && items.map(it => (
            <MenuItem key={it.id} onClick={()=> onAdd(it)}>{it.display || it.id}</MenuItem>
          ))}
        </SubMenu>
      ))}
    </Menu>
  );
}
